import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
} from "antd";
import signinbg from "../assets/images/People Pinnacle Logo.png";
import {
  DribbbleOutlined,
  TwitterOutlined,
  InstagramOutlined,
  GithubOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getLogin } from "../store/reducers/authSlice";

const { Title } = Typography;
const { Footer, Content } = Layout;

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message, status } = useSelector((state) => state.authSlice);

  const onFinish = async (values) => {
    setLoading(true); // Step 2
    try {
      const response = await dispatch(getLogin(values));
      console.log("response", response);

      if (response?.status === 200) {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setLoading(false); // Step 3
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Layout
      style={{ height: "100vh" }}
      className="layout-default layout-signin"
    >
      <Content style={{ marginTop: "10rem" }} className="signin">
        <Row gutter={[24, 0]} justify="space-around">
          <Col
            xs={{ span: 24, offset: 0 }}
            lg={{ span: 6, offset: 2 }}
            md={{ span: 12 }}
          >
            <Title className="mb-15">Sign In</Title>
            <Title className="font-regular text-muted" level={5}>
              Enter your user name and password to sign in
            </Title>
            <Form
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col"
            >
              <Form.Item
                className="username"
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input placeholder="email" />
              </Form.Item>

              <Form.Item
                className="username"
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item
                // name="remember"
                className="aligin-center"
                valuePropName="checked"
              >
                <Switch defaultChecked />
                Remember me
              </Form.Item>

              <Form.Item>
                <Button
                  className="bg-blue-500 hover:bg-blue-600 text-white"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={loading}
                >
                  SIGN IN
                </Button>
              </Form.Item>
              {/* <p className="font-semibold text-muted">
                Don't have an account?{" "}
                <Link to="/sign-up" className="text-dark font-bold">
                  Sign Up
                </Link>
              </p> */}
            </Form>
          </Col>
          <Col
            className="sign-img"
            style={{ padding: 12 }}
            // xs={24}
            // lg={12}
            // md={12}
          >
            <img src={signinbg} alt="" />
          </Col>
        </Row>
      </Content>

      <Footer>
        {/* <Menu mode="horizontal">
          <Menu.Item>Company</Menu.Item>
          <Menu.Item>About Us</Menu.Item>
          <Menu.Item>Teams</Menu.Item>
          <Menu.Item>Products</Menu.Item>
          <Menu.Item>Blogs</Menu.Item>
          <Menu.Item>Pricing</Menu.Item>
        </Menu>
        <Menu mode="horizontal" className="menu-nav-social">
          <Menu.Item>
            <Link to="#">
              <DribbbleOutlined />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">
              <TwitterOutlined />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">
              <InstagramOutlined />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">
              <svg
                width="18"
                height="18"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M496 256c0 137-111 248-248..." />
              </svg>
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">
              <GithubOutlined />
            </Link>
          </Menu.Item>
        </Menu> */}
        <p className="copyright">
          Copyright © 2025 <a href="#pablo">Rabt AI</a>
        </p>
      </Footer>
    </Layout>
  );
};

export default SignIn;
